import React from 'react';
import MenuItem from '../MenuItem';
import { FilterItemProps, FilterTypes } from '../utils/types';
import RangeFilterItem from './RangeFilterItem';
import SelectionFilterItem from './SelectionFilterItem';

function FilterItem(props: FilterItemProps<FilterTypes>) {
    return (
        <MenuItem
            title={getFilterTitle(props)}
            id={props.item.fieldId}
            dataAuto={`filter-item-${props.item.fieldId}`}
        >
            {props.type === FilterTypes.BETWEEN ? (
                <RangeFilterItem
                    {...(props as FilterItemProps<FilterTypes.BETWEEN>)}
                />
            ) : (
                <SelectionFilterItem
                    {...(props as FilterItemProps<FilterTypes.ONE_OF>)}
                />
            )}
        </MenuItem>
    );
}

export default FilterItem;

function getFilterTitle({
    type,
    currentValues,
    item,
}: FilterItemProps<FilterTypes>): string {
    if (type === FilterTypes.ONE_OF) {
        const count = Array.isArray(currentValues) ? currentValues.length : 0;
        return count > 0
            ? `${item.fieldDisplayName} (${count})`
            : item.fieldDisplayName;
    }

    if (type === FilterTypes.BETWEEN && currentValues) {
        return `${item.fieldDisplayName} (1)`;
    }

    return item.fieldDisplayName;
}
